import type { Geometry } from 'geojson'
import type { Route } from './Route'

export type PartialLine = {
  id: string
  color: string
  textColor: string
  network: string | null
  mode: string
  code: string
  tod: string | null
}

export type Line = PartialLine & {
  routes: Route[]
  geojson: Geometry | null
}

export type AutocompleteLine = PartialLine & {
  od: {
    name: string
    boundaries: string[]
  }[]
}

export function isFullLine(line: PartialLine | Line): line is Line {
  return 'routes' in line
}
